import { all, takeEvery } from 'redux-saga/effects';
import { ACTIONS } from '../types';
import { doubleBetSaga } from './doubleBetSaga';

export function* betDoubleRootSaga() {
  yield all([takeEvery(ACTIONS.DOUBLE_BET, doubleBetSaga)]);
}
